/** Пресеты галок «планы в оплате» — не каталоги legacy/current. */
export const GRANDFATHER_PLAN_CODES = new Set(["basic", "pro", "business"]);

export function planIdsByCodes(plans, codes) {
  const set = codes instanceof Set ? codes : new Set(codes);
  return (plans || [])
    .filter((p) => set.has(p.code))
    .map((p) => String(p.id));
}

export function planIdsPublic(plans) {
  return (plans || []).filter((p) => p.is_public).map((p) => String(p.id));
}

export function planIdsAll(plans) {
  return (plans || []).map((p) => String(p.id));
}

/** Что клуб реально видит в оплате (явный список или fallback). */
export function resolveClubOfferIds(clinic, plans) {
  const stored = Array.isArray(clinic?.offer_plan_ids)
    ? clinic.offer_plan_ids.map(String)
    : Array.isArray(clinic?.billing?.offer_plan_ids)
      ? clinic.billing.offer_plan_ids.map(String)
      : [];
  if (stored.length) return stored;
  const isGrandfather =
    clinic?.billing_catalog === "legacy" ||
    clinic?.billing?.billing_catalog_stored === "legacy";
  if (isGrandfather) return planIdsByCodes(plans, GRANDFATHER_PLAN_CODES);
  return planIdsPublic(plans);
}

export function offerPlanNames(ids, plans) {
  const set = new Set((ids || []).map(String));
  return (plans || [])
    .filter((p) => set.has(String(p.id)))
    .map((p) => p.name);
}
